import { onboarding } from '@services';
import OnboardingGroup, {
  IOnboardingGroup,
  IOnboardingGroupApi,
  IPaginationResultGroups,
} from '@models/OnboardingGroup.model';

interface IRequest {
  studioId?: string;
  fileId?: string;
  groupId?: string;
}

const getRequestDetails = async ({
  studioId,
  fileId,
  groupId,
}: IRequest): Promise<IPaginationResultGroups<IOnboardingGroup>> => {
  const { data: groups } = await onboarding.get<
    IPaginationResultGroups<IOnboardingGroupApi>
  >('/api/v1/assets/search/status', {
    params: {
      studioId,
      fileId,
      status: 'identification_requested',
      isGrouped: true,
      groupId,
    },
  });

  return OnboardingGroup.arrayPaginatedFromApiModel(groups);
};

export { getRequestDetails };
